"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemoveDocument = void 0;
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var react_1 = require("react");
var useRemoveDocument = function () {
    var _a = (0, useMutation_1.useMutation)({
        keysUpdate: [
            keys_1.GET_MY_DOCUMENTS_IDENTITY,
            keys_1.GET_MY_DOCUMENTS_ADDRESS,
            keys_1.GET_MY_DOCUMENTS_PAYMENT,
            keys_1.USER_KYC,
        ],
        path: keys_1.REMOVE_MY_DOCUMENTS,
    }), mutate = _a.mutate, isSubmitting = _a.isSubmitting, error = _a.error;
    return (0, react_1.useMemo)(function () { return ({
        removeDocument: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useRemoveDocument = useRemoveDocument;
